module.exports = __webpack_public_path__ + "static/assets/3c06b74c80d1e6b1d210ca86c87cd326.svg";